__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-05-1770279193-stable-dev/";